import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseRequest extends BaseModel {
  static override constructorName = 'ResearchShowcaseRequest'

  fio: string = ''
  'company_name': string = ''
  comments: string = ''
  position: string = ''
  email: string = ''
  phone: string = ''
  'terms_accepted': boolean = false
  'privacy_accepted': boolean = false
  'policy_accepted': boolean = false
  'marketing_accepted': boolean = false
  status: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseRequest)
